import {IChar} from "../_interfaces/IChar";
import {v4} from "uuid";

const defaultChar: IChar = {
    id: v4(),
    name: "",
    pname: "",
    nsc: false,
    race: "",
    visible: true,
    cc_attr: false,
    cc_skills: false,
    cc_talents: false,

    kv: 0,
    mv: 0,
    sv: 0,

    wund: 0,
    bew: 0,
    tot: 0,

    ges: 0,
    ges_c: 0,
    ges_r: 0,
    ges_k: false,
    str: 0,
    str_c: 0,
    str_r: 0,
    str_k: false,
    zae: 0,
    zae_c: 0,
    zae_r: 0,
    zae_k: false,
    wah: 0,
    wah_c: 0,
    wah_r: 0,
    wah_k: false,
    wil: 0,
    wil_c: 0,
    wil_r: 0,
    wil_k: false,
    cha: 0,
    cha_c: 0,
    cha_r: 0,
    cha_k: false,

    schaden: 0,
    blutschaden: 0,
    wunden: 0,
    blutwunden: 0,

    pr: 0,
    mr: 0,

    ep: 0,
    ep_used: 0,
    ep_karma: false,

    karma: 0,
    karma_max: 0,


    orichalcum: 0,
    gold: 0,
    silver: 0,
    copper: 0,


    lp_sum: 0,
    lp_current: 0,

};

export default defaultChar